import { PERMISSIONS } from '../../../../config/permissions';

export const SUPPLIER_PROFILE_TAB_KEYS = {
  personal: 'personal',
  banks: 'banks',
  demat: 'demat',
  transactions: 'transactions',
};

const TAB_PERMISSIONS = {
  [SUPPLIER_PROFILE_TAB_KEYS.personal]: PERMISSIONS.SUPPLIERS_VIEW,
  [SUPPLIER_PROFILE_TAB_KEYS.banks]: PERMISSIONS.SUPPLIERS_VIEW,
  [SUPPLIER_PROFILE_TAB_KEYS.demat]: PERMISSIONS.SUPPLIERS_VIEW,
  [SUPPLIER_PROFILE_TAB_KEYS.transactions]: PERMISSIONS.PRODUCT_PRE_IPO_PURCHASE_DEAL_SHEET_VIEW,
};

export function canViewSupplierProfileTab(tabKey, hasPermission, isSuperAdmin) {
  if (isSuperAdmin) return true;
  const permission = TAB_PERMISSIONS[tabKey];
  return permission ? hasPermission(permission) : true;
}

export function getAllowedSupplierProfileTabs(hasPermission, isSuperAdmin) {
  return Object.values(SUPPLIER_PROFILE_TAB_KEYS).filter((key) =>
    canViewSupplierProfileTab(key, hasPermission, isSuperAdmin)
  );
}

export function resolveSupplierProfileTab(tabFromUrl, hasPermission, isSuperAdmin) {
  const allowed = getAllowedSupplierProfileTabs(hasPermission, isSuperAdmin);
  if (tabFromUrl && allowed.includes(tabFromUrl)) return tabFromUrl;
  return allowed[0] || SUPPLIER_PROFILE_TAB_KEYS.personal;
}

export function mapSupplierProfileSectionToTab(section) {
  if (section === 'bank_details') return SUPPLIER_PROFILE_TAB_KEYS.banks;
  return '';
}

export function resolveSupplierProfileTabFromParams({ tab, section, hasPermission, isSuperAdmin }) {
  const tabKey = tab || mapSupplierProfileSectionToTab(section);
  return resolveSupplierProfileTab(tabKey, hasPermission, isSuperAdmin);
}

const ONBOARDING_STEP_LABELS = {
  STEP_1_PAN: 'PAN Verification',
  STEP_2_DETAILS: 'Personal Details',
  STEP_3_BANK: 'Bank Details',
  STEP_4_DEMAT: 'Demat Details',
  STEP_5_CML: 'CML Upload',
  COMPLETED: 'Completed',
};

export function formatSupplierOnboardingStep(step) {
  if (!step) return '—';
  return ONBOARDING_STEP_LABELS[step] || String(step).replace(/_/g, ' ');
}

export function resolvePrimaryContact(pool = []) {
  if (!Array.isArray(pool) || pool.length === 0) return '—';
  const primary = pool.find((item) => item.is_primary) || pool[0];
  return primary?.value || '—';
}

export function normalizeDocumentUrl(url) {
  if (!url) return '';
  const duplicatedHostMatch = String(url).match(/^(https?:\/\/[^/]+)\/\1(\/.*)$/);
  if (duplicatedHostMatch) {
    return `${duplicatedHostMatch[1]}${duplicatedHostMatch[2]}`;
  }
  return String(url);
}
